module.exports = __webpack_public_path__ + "media/images/steps/png/205-deal-e01a8d6c4e9c93ef4beec19280c8e2e5.png";